import React, { useState } from 'react';
import { Box, Button, IconButton, Modal, TextField, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { AppDispatch, RootState } from '../../store/store';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../store/hooks';
import SearchResultGrid from '../searchResultGrid/searchResultGrid';
import modalStyle from '../../styles/modalStyle';
import apiClient from '../../axiosClient';
import { textPattern, textWithoutSpacePattern } from '../../constants/patterns';
import Agency from '../../interfaces/agency';
import { loadAgencies } from '../../store/slices/agencySlice';
import agencyColumnDef from '../../colDef/agencyColumnDef';

const ManageAgency = () => {
    const dispatch: AppDispatch = useAppDispatch();
    const agencies: Agency[] = useSelector((state: RootState) => state.agencies.agencies);
    const [openModal, setOpenModal] = useState(false);
    const [name, setName] = useState<string>('');
    const [agencyName, setAgencyName] = useState<string>('');
    const [agencyAddress, setAgencyAddress] = useState<string>('');
    const [agencyContact, setAgencyContact] = useState<string>('');
    const handleOpenModal = () => setOpenModal(true);

    const handleCloseModal = () => {
        setName('');
        setAgencyName('');
        setAgencyContact('');
        setAgencyAddress('');
        setOpenModal(false);
    };

    const handleSubmit = async () => {
        try {

            if (!agencyName || !agencyContact || !agencyAddress || !name) {
                alert('Please fill all required values');
                return;
            }
            const response = await apiClient.post('/api/v1/agency',
                {
                    name,
                    agency_name: agencyName,
                    agency_address: agencyAddress,
                    agency_contact: agencyContact
                }
            );
            if (response.status === 200) {
                const newAgencies = [...agencies, response.data as Agency];
                dispatch(loadAgencies(newAgencies));
                handleCloseModal();
                alert('Success: Agency created successfully');
            } else {
                alert('Error: Could not create agency');
            }
        } catch (error: any) {
            if (error.response) {
                alert('Error response data:' + error.response.data.message);
            } else if (error.request) {
                alert('No response received:' + error.request);
            } else {
                alert('Error message:' + error.message);
            }
        }
    };

    return (
        <Box m={2}>
            <Box display="flex" justifyContent="flex-end" marginY="10px">
                <Button variant="contained" onClick={handleOpenModal}>
                    Add New Agency
                </Button>
            </Box>

            <SearchResultGrid
                height='80vh'
                getRowId={(row: Agency) => row.agency_name}
                results={agencies}
                onSelectRow={() => { }}
                columns={agencyColumnDef}
            />

            <Modal open={openModal} onClose={handleCloseModal}>
                <Box sx={modalStyle}>
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <Typography id="modal-title" variant="h6">
                        Add New Agency
                        </Typography>
                        <IconButton onClick={handleCloseModal}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                    <TextField
                        label="Agency Name"
                        name="agency name"
                        value={agencyName}
                        onChange={(event) => setAgencyName(event?.target.value.replace(textWithoutSpacePattern, ""))}
                        fullWidth
                        required
                        margin="normal"
                    />
                    <TextField
                        label="Name"
                        name="name"
                        value={name}
                        onChange={(event) => setName(event?.target.value.replace(textPattern, ""))}
                        fullWidth
                        required
                        margin="normal"
                    />
                    <TextField
                        label="Agency Address"
                        name="address"
                        value={agencyAddress}
                        onChange={(event) => setAgencyAddress(event?.target.value.replace(textPattern, ""))}
                        fullWidth
                        required
                        margin="normal"
                    />
                    <TextField
                        label="Agency Contact"
                        name="contact"
                        value={agencyContact}
                        onChange={(event) => setAgencyContact(event?.target.value.replace(textPattern, ""))}
                        fullWidth
                        required
                        margin="normal"
                    />
                    <Box mt={2} textAlign="right">
                        <Button variant="contained" color="primary" onClick={handleSubmit}>
                            Submit
                        </Button>
                    </Box>
                </Box>
            </Modal>
        </Box>
    );
};

export default ManageAgency;